import React from "react"
import Ig from "./img/instagram.png"
import Fb from "./img/facebook.png"
import Wa from "./img/whatsapp.png"
import Yt from "./img/youtube.png"

function About() {
	return (
		<div className="about">
			<div className="about-l">
				<p>We're an India based digital Blog agency.</p>
				<br />
				<p>
					Since 2020, we’ve been on a mission to help brands become more human
					in the digital era. Today we’re a tight-knit team of 20 strategists,
					creatives and developers, focusing on one thing: taking care of your
					brand across multiple digital touch-points.
				</p>
				<br />
				<p>
					We believe that brands become more human when they’re accessible,
					social and emotional. As a strategic partner we craft effective brand
					strategies, digital first identities and online products that make
					brand stand out and become more human.
				</p>
			</div>
			<div className="about-r">
				<div className="about-r-u">
					<div className="about-r-u-l">
						<p>harshuuu814@gmail.com</p>
						<p>+91 9983396152</p>
					</div>
					<div className="about-r-u-r">
						<p>Jaipur</p>
						<p>302016 Shastri Nagar</p>
					</div>
				</div>
				<div className="about-r-d">
					<img src={Ig} alt="" />
					<img src={Fb} alt="" />
					<img src={Wa} alt="" />
					<img src={Yt} alt="" />
				</div>
			</div>
		</div>
	)
}

export default About
